import { useEffect, useState } from "react";
import GenericTable from "../shared/components/table.component";
import { getAnalyticsData } from "./analytics-utilities";

import { Navigate, useLocation } from "react-router-dom";
import { loggerService } from "../../services";
import dateService from "../../services/date.service";

import { IProjectDetails } from "../../interfaces";
import { useDateFilterStore, useOrganizationStore } from "../../store";
import { Pagination } from "../shared/components";
import { PaginationProps } from "../shared/config";
import AnalyticsTime from "./components/analytics-time-line.component";

export interface rawDataInterface {
  id: number,
  organizationId: number,
  sourceApp: string;
  eventType: string;
  eventData: string;
  eventSubType: string;
  externalUserId: string;
  sessionId: string;
  createdAt: string;
}

export interface IApplogs {
  events: rawDataInterface[];
  total: number;
}

interface EventRowInterface {
  rawData: rawDataInterface[];
  setRawData: (rawData: rawDataInterface[]) => void;
}

const Rawdata: React.FC = () => {
  const [rawData, setRawData] = useState<rawDataInterface[]>(null);
  const location = useLocation();
  const getProjects = useOrganizationStore((state) => state.getProjects);
  const projectDetails: IProjectDetails[] = getProjects();
  const projectId = location.pathname.split("/")[3];

  const projectData: IProjectDetails = projectDetails.find((project) => project.module === projectId);
  const colDefs = [
    {
      name: "Source App",
      type: "string",
      field: "sourceApp"
    },
    {
      name: "Event Type",
      type: "string",
      field: "eventType"
    },
    {
      name: "Event SubType",
      type: "string",
      field: "eventSubType"
    },
    {
      name: "Event Data",
      type: "string",
      field: "eventData"
    },
    {
      name: "Organization ID",
      type: "number",
      field: "organizationId"
    },
    {
      name: "Created At",
      type: "date",
      field: "createdAt"
    }
  ];
  const [totalRows, setTotalRows] = useState<number>(0);
  const rowsPerPage = PaginationProps.rowsPerPage;

  const [skipNumber, setSkipNumber] = useState<number>(0);

  const selectedDatesInFilter = useDateFilterStore((state) => state.selectedDates);
  const setSelectedDateFilter = useDateFilterStore((state) => state.setSelectedDateFilter);

  useEffect(() => {
    setSkipNumber((prevSkipNumber) => 0);
    setSelectedDateFilter({ startDate: null, endDate: null });
  },[location.pathname]);

  useEffect(() => {
    try {
      getAnalyticsData(
        selectedDatesInFilter?.startDate,
        selectedDatesInFilter?.endDate,
        projectData.module,
        setRawData,
        skipNumber,
        setTotalRows
      );
    } catch (error) {
      loggerService.error(error);
    }
  }, [location.pathname, skipNumber]);



  if (!projectData) {
    return <Navigate to="/404" />;
  }

  const pageChangeHandler = (currentPage) => {
    const skip = (currentPage - 1) * rowsPerPage;
    setSkipNumber(skip);
  };

  return (
    <main className="px-8">
      <AnalyticsTime
        setRawData={setRawData}
        appName={projectData.module}
        setTotalRows={setTotalRows}
      />

      {/* {!rawData && (
        <div className="flex justify-center items-center h-96">
          <div role="status">
            <svg
              aria-hidden="true"
              className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )} */}

      {rawData?.length > 0 && (
        <GenericTable
          column={colDefs}
          row={rawData.map((item) => ({
            sourceApp: item.sourceApp,
            eventType: item.eventType,
            eventSubType: item.eventSubType,
            eventData: item.eventData !== 'null' ? item.eventData : '',
            organizationId: item.organizationId,
            createdAt: dateService.convertToDDMMYYYYFormat(item.createdAt),
          }))}
          searchField="sourceApp"
          searchTerm=""
        />
      )}
      {rawData?.length === 0 && (
        <div className="flex justify-center items-center h-96">
          No Data Found
        </div>
      )}
      {rawData?.length > 0 && (
        <Pagination totalRows= {totalRows} pageCount={ Math.ceil(totalRows / rowsPerPage)} onPageChange={pageChangeHandler} rowsPerPage={rowsPerPage} />
      )}
    </main>
  );
};

export default Rawdata;
